import { render } from "./ReportsPage.vue?vue&type=template&id=0f935493&scoped=true"
import script from "./ReportsPage.vue?vue&type=script&lang=js"
export * from "./ReportsPage.vue?vue&type=script&lang=js"

import "@/assets/css/reports.css?vue&type=style&index=0&lang=css&external"
import "./ReportsPage.vue?vue&type=style&index=1&id=0f935493&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f935493"]])

export default __exports__